import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { AppContextProvider } from './context/AppContext';
import { BadgeProvider } from './context/BadgeContext'; 
import { Provider } from 'react-redux';
import store from './store';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContextProvider>
        <BadgeProvider>
          <RouterProvider router={router} />
        </BadgeProvider>
      </AppContextProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
